import React from "react";

const Aside = ({ materia }) => {
  if (!materia) return null;

  const { MON, TUE, WED, THU, FRI, BEGIN, END } = materia;

  const trim = (str) => str?.trim();

  const dias = [
    { nombre: "Lunes", valor: trim(MON) },
    { nombre: "Martes", valor: trim(TUE) },
    { nombre: "Miércoles", valor: trim(WED) },
    { nombre: "Jueves", valor: trim(THU) },
    { nombre: "Viernes", valor: trim(FRI) },
  ];

  const diasDisponibles = dias
    .filter((d) => d.valor)
    .map((d) => d.nombre)
    .join(", ");

  return (
    <div className="d-flex justify-content-center mt-4">
      <aside className="bg-light p-4 border rounded text-center">
        <h5 className="mb-3">Horario de la actividad:</h5>
        <table className="table table-sm mb-0">
          <tbody>
            {diasDisponibles && (
              <tr>
                <th className="text-center">Días</th>
                <td>{diasDisponibles}</td>
              </tr>
            )}
            {(BEGIN || END) && (
              <tr>
                <th className="text-center">Horario</th>
                <td>{BEGIN || "-"} a {END || "-"}</td>
              </tr>
            )}
          </tbody>
        </table>
      </aside>
    </div>
  );
};

export default Aside;
